export default __webpack_public_path__ + "static/media/jrvclassics_tile_top.1478b47d.jpg";